import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import useEndpoints from "../../api/useEndpoints";
import Storages from "../../helper/storages";
import HistoryInfoCard from "./historyInfoCard";
import ErrorHandler from "../../api/errorHandler";
import HistoryInfoRowTable from "./historyInfoRowTable";
import RowHeader from "./historyInfoRowHeader";

import { useLocation } from "react-router-dom";
import Paths from "./../../config/paths.json";
import dashboardContext from "../../contexts/dashboardContext";
import DateComponent from "../DateComponent";
export default function CanceledService(props) {
  var endpoints = useEndpoints();
  var [list, setList] = useState([])
  var parent = useRef()
  const location = useLocation()
  var dContext = useContext(dashboardContext);


  const getData = () => {
    let params = {
      fromDate: props.startDate,
      toDate: props.endDate,
    };
    axios.get(endpoints.canceledService,
      {
        headers:
        {
          'x-auth-token': Storages.getUserToken()
        },
        params: params,
      }).then((res) => {
        setList(res.data.result)
      }).catch((e) => {
        console.log(e)
        ErrorHandler(e)
      })
  }



  useEffect(() => {
    getData()
  }, [props])

  return (
    <>  {(location.pathname == Paths.dashboard || dContext.isMobile)
      ? (<div className="d-flex flex-column m-0 p-0" ref={parent}>
        {
          list.map((item, index) => {
            return <HistoryInfoCard item={item} />
          })
        }
      </div>)
      : (<>

        <table className="table table-sm table-striped bg-light">
          <thead className="thead-dark">
            <RowHeader />
          </thead>
          <tbody className="thead-dark">
            {
              list.map((item, index) => {
                return (
                  <HistoryInfoRowTable item={item} />
                )
              })
            }

          </tbody>
        </table>
      </>
      )
    }</>
  )
}